import { apiCall } from "@/shared/lib/api-call";
import { apiPaths } from "@/shared/lib/api-paths";
import {
  type GenerateDraftRequest,
  generateDraftRequestSchema,
  type SurfaceDraft,
  surfaceDraftSchema,
} from "@/shared/writing-assistant/writing-assistant.schema";

/// HTTP boundary for the writing assistant. One POST, stateless; the
/// response is Zod-parsed per T3 / FE-SEC6.
export async function generateDraft(
  workspaceId: string,
  input: GenerateDraftRequest,
): Promise<SurfaceDraft> {
  // Parse outbound body so the schema is load-bearing, not just a type alias.
  const body = generateDraftRequestSchema.parse(input);
  return apiCall<SurfaceDraft>(
    apiPaths.writingAssistant.drafts(workspaceId),
    { method: "POST", body: JSON.stringify(body) },
    surfaceDraftSchema,
  );
}
